import { FETCH_MOVIE_BY_ACTORS } from 'src/services/GraphQL/Queries/MovieByActors';
import { graphQlRequest } from 'src/services/GraphQL/RequestHandler';
import { DynamicObject } from 'src/utils/commonTypes';

import { HTTP_HEADER_KEYS } from '../../../utils/constants/HttpMethodsConstants';

const generateMovieByActorsQueryParams = (
  country: string,
  languages: string,
  actors: string
) => {
  const queryParams = {
    filter: {
      page: 1,
      limit: 25,
      country: country,
      translation: 'en',
      assetSubType: 'movie',
      version: '2',
      sortBy: 'release_date',
      sortOrder: 'desc',
      languages: languages,
      actors: actors,
      actorsType: 'all'
    }
  };
  return queryParams;
};

export const fetchRailsByActors = async (reqObj: DynamicObject) => {
  const { country, languages, actors } = reqObj;
  const headers = [HTTP_HEADER_KEYS.X_ACCESS_TOKEN];
  const params = generateMovieByActorsQueryParams(country, languages, actors);
  try {
    const response = await graphQlRequest(
      FETCH_MOVIE_BY_ACTORS,
      params,
      '',
      headers
    );
    return response?.moviesByActors || [];
  } catch (error) {
    console.error('Error while fetching movieByActors: ', error);
    return [];
  }
};
